import { connect } from "react-redux";
import { useEffect } from "react";
import { getDocuments } from "./actions";
import DocumentsTable from "./components/DocumentsTable";
import "./index.scss";

const Documents = ({ loading, getDocuments, ...props }) => {
  useEffect(() => {
    getDocuments();
  }, [getDocuments]);

  return (
    <div className="container documents">
      <div className="documents-header">
        <h1 className="heading title">Documents</h1>
        <p className="subheading text-grey">
          View and download your documents.
        </p>
      </div>
      <DocumentsTable />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.documents.loading,
  };
};

export default connect(mapStateToProps, {
  getDocuments,
})(Documents);
